/*
 * Copyright (c) Viucom GmbH 2021.
 */

/**
 * Variable Definitions
 */
var _cfg = _config || {};
var _trans = _translation || {};

var userAgent = navigator.userAgent.toLowerCase(),
    initialDate = new Date(),

    $document = $(document),
    $window = $(window),
    $html = $("html"),

    isDesktop = $html.hasClass("desktop"),
    isIE = userAgent.indexOf("msie") != -1 ? parseInt(userAgent.split("msie")[1]) : userAgent.indexOf("trident") != -1 ? 11 : userAgent.indexOf("edge") != -1 ? 12 : false,
    isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    isTouch = "ontouchstart" in window,
    onloadCaptchaCallback,
    plugins = {
        parsley: $(".js-parsley-validation"),
        actionChanger: $(".js-action-changer"),
        videoJs: $(".js-video-js"),
        cookie: $(".js-cookie"),
        slider: $(".js-slider"),
        lightbox: $(".js-lightbox"),
        dropdown: $(".dropdown"),
        click: $(".js-click"),
        carousel: $(".js-carousel"),
        topBarNotice: $(".js-top-bar-notice"),
        registrationForm: $(".js-registration-form"),
        videoPlay: $(".js-video-play"),
        newsletterConsent: $(".js-newsletter-checkbox")
    };


/**
 * Document Ready
 */
$(document).ready(function () {

    /**
     * Load Script
     * @description Load Script via JS
     */
    $.loadScript = function (url, callback) {
        $.ajax({
            url: url,
            dataType: 'script',
            success: callback,
            async: true
        });
    }

    /**
     * Slick Slider
     * @description Slick Slider for Images
     */
    if (plugins.slider.length) {
        $('.js-slider').slick();
    }

    /**
     * Carousel
     * @description Bootstrap Carousel with Swipe functionality
     */
    if (plugins.carousel.length) {

        // Lazy Loading for images
        $('.carousel.lazy-load').bind('slide.bs.carousel', function (e) {
            var image = $(e.relatedTarget).find('img[data-src]');
            image.attr('src', image.data('src'));
            image.removeAttr('data-src');
        });

        // Carousel Initialization
        $('.js-carousel').carousel({
            interval: 10000,
            pause: "hover"
        });

        // Swipe function for Carousel
        $( ".carousel .carousel-swipe" ).swipe( {
            swipeLeft: function ( event, direction, distance, duration, fingerCount ) {
                this.parent( ).carousel( 'next' );
            },
            swipeRight: function ( ) {
                this.parent( ).carousel( 'prev' );
            },
            threshold: 0,
            excludedElements:"label, button, input, select, textarea, .noSwipe"
        } );

        $('.carousel .carousel-swipe').on('dragstart', 'a', function () {
            return false;
        });
    }

    /**
     * Lightbox
     */
    if(plugins.lightbox.length){
        $( ".js-lightbox" ).each(function( index ) {
            $( this ).lightGallery();
        });
    }

    /**
     * Click Action
     * @description Click Action for HTML Elements e.g. Teaser
     */
    if(plugins.click.length){
        $( ".js-click" ).on('click', function(e) {

            let a = $( this ).find('a:first');
            let href = a.attr('href');

            if(href !== undefined){

                let target = a.attr('target');

                if(target === '_blank'){
                    window.open(href);
                }else{
                    window.location.href = href;
                }
            }
        });
    }


    /**
     * Parsley Validation
     * @description Enables Parsley
     */
    if (plugins.parsley.length) {

        var parsleyOptions = {
            successClass: 'has-success',
            errorClass: 'has-error',
            classHandler : function( _el ){
                return _el.$element.closest('.form-group');
            },
            errorsContainer: function (_el) {
                return _el.$element.closest('.form-group');
            }
        };

        $.loadScript('/static/build/js/parsley/parsley.min.js', function () {

            $('.js-parsley-validation').parsley(parsleyOptions);

            var $parsleyElements = $('.js-parsley-validation');
            if ($parsleyElements && $parsleyElements.length) {
                $parsleyElements.parsley().on('field:error', function() {
                    var parsleyId = $(this)[0].__id__;
                    $(this)[0].$element.attr({
                        'aria-invalid': "true",
                        'aria-describedby': 'parsley-id-'+ parsleyId
                    });
                });
                $parsleyElements.parsley().on('field:success', function() {
                    $(this)[0].$element.removeAttr('aria-invalid aria-describedby');
                });
            }

            var $parsleyElementsSnd = $('.js-parsley-validation-snd');
            if ($parsleyElementsSnd && $parsleyElementsSnd.length) {
                $parsleyElementsSnd.parsley().on('field:error', function() {
                    var parsleyIdSnd = $(this)[0].__id__;
                    $(this)[0].$element.attr({
                        'aria-invalid': "true",
                        'aria-describedby': 'parsley-id-'+ parsleyIdSnd
                    });
                });
                $parsleyElementsSnd.parsley().on('field:success', function() {
                    $(this)[0].$element.removeAttr('aria-invalid aria-describedby');
                });
            }
        });
    }

    /**
     * Action Changer
     * @description Changes the action of form
     */
    if (plugins.actionChanger.length) {

        $(".js-action-changer").on('submit', function () {
            var newAction = $(this).data('action');
            if (newAction) {
                $(this).attr('action', newAction);
            } else {
                $(this).attr('action', '');
            }
        });
    }

    /**
     * Video JS
     * @description Enables Video JS
     */
    if (plugins.videoJs.length) {
        $.getScript("/static/build/js/videojs-ie8.min.js");
    }


    /**
     * Cookie Modal
     * @description Cookie Modal Functionalities
     */
    if (plugins.cookie.length) {

        if(localStorage.getItem("sphc-hide-cookiebar") == 'true'){
            $('#cookie-bar').hide();
        }

        $(".btn-cookie-accept").on('click', function (event) {

            event.preventDefault();

            localStorage.setItem("sphc-hide-cookiebar", "true");
            localStorage.setItem("sphc-accept-cookies", "true");

            var nDays = 999;
            var cookieName = "sphc-accept-cookies";
            var cookieValue = "true";

            var today = new Date();
            var expire = new Date();

            expire.setTime(today.getTime() + 3600000*24*nDays);
            document.cookie = cookieName+"="+escape(cookieValue)+";expires="+expire.toGMTString()+";path=/";

            $('#cookie-bar').hide();

            // Reload Page
            location.reload();
        });

        $(".btn-cookie-decline").on('click', function (event) {

            event.preventDefault();

            localStorage.setItem("sphc-hide-cookiebar", "true");
            localStorage.setItem("sphc-accept-cookies", "false");

            var nDays = 999;
            var cookieName = "sphc-accept-cookies";
            var cookieValue = "false";

            var today = new Date();
            var expire = new Date();

            expire.setTime(today.getTime() + 3600000*24*nDays);
            document.cookie = cookieName+"="+escape(cookieValue)+";expires="+expire.toGMTString()+";path=/";

            $('#cookie-bar').hide();
        });
    }


    /**
     * Dropdown Menu
     * @description Dropdown Menu Functionality
     */
    if (plugins.dropdown.length) {
        plugins.dropdown.hover(
            function() {
                $(this).addClass("show");
                $(this).find(".dropdown-menu").attr("aria-expanded", "true");
                $(this).find(".dropdown-menu").addClass("show");
            },
            function() {
                $(this).removeClass("show");
                $(this).find(".dropdown-menu").attr("aria-expanded", "false");
                $(this).find(".dropdown-menu").removeClass("show");
            }
        );
    }

    /**
     * Top Bar Notice
     * @description Top Bar Notice for messages
     */
    if (plugins.topBarNotice.length) {

        // Hide Top Bar Notice on scroll
        $(window).on('scroll', function (e){
            if ($(window).scrollTop() >= ($(document).height() - $(window).height())*0.1){
                $( ".js-top-bar-notice" ).fadeOut(1000);
                $( ".site-container" ).css("padding-top", "90px");
            }
        });

        // Hide Top Bar Notice on clicking x
        $( "#hide-top-bar-notice" ).on('click', function(e) {
            $( ".js-top-bar-notice" ).fadeOut(1000);
            $( ".site-container" ).css("padding-top", "90px");
        });
    }

    /**
     * Registration Form
     * @description Enables Registration Request Form
     */
    if (plugins.registrationForm.length) {

        $(".js-registration-form").on('submit', function (event) {

            if ($('.js-registration-form').parsley().isValid()) {

                // Prevent send form
                event.preventDefault();

                // Get Action
                var action = $(this).data('action');

                // Parameters
                var params = [];

                // Add Parameters
                if($("#email").val()){
                    params.push('email=' + $("#email").val());
                }
                if($("#firstname").val()){
                    params.push('firstname=' + $("#firstname").val());
                }
                if($("#lastname").val()){
                    params.push('lastname=' + $("#lastname").val());
                }
                if($("#telephone").val()){
                    params.push('telephone=' + $("#telephone").val());
                }
                if($("#interests").val()){
                    params.push('interests=' + $("#interests").val());
                }
                if($("#gdpr").val()){
                    params.push('gdpr=' + $("#gdpr").val());
                }
                if($("#newsletter").prop('checked')){
                    params.push('newsletter=' + $("#newsletter").val());
                }
                if($("#email-document-admin").val()){
                    params.push('email-document-admin=' + $("#email-document-admin").val());
                }


                params = params.join("&");

                // Hide Registration Form
                $('.js-registration-form').fadeOut("slow");

                // Spam Check
                if($('#mobilenumber').val() != null) {

                    $.ajax({
                        method: "POST",
                        url: action,
                        data: params,
                        success: function (obj) {
                            $('#registration-form-success-msg').html(obj.message);
                            $('#registration-form-success-msg').fadeIn("slow");
                        },
                        error: function (xhr, status, error) {
                            // Ajax Error Message
                            $('#registration-form-error-msg').html(obj.message);
                            $('#registration-form-success-msg').fadeIn("slow");
                            return false;
                        }
                    })
                }else{
                    $('#registration-form-error-msg').html(_trans.registrationRequestSpamFail);
                    $('#registration-form-success-msg').fadeIn("slow");
                }
            }
        });
    }

    /**
     * Play Video on click
     * @description Video Play Button
     */
    if (plugins.videoPlay.length) {
        $( ".js-video-play" ).on('click', function(e) {
            $(this).children( ".video-overlay" ).fadeOut("slow");
            $(this).find( "video" ).get(0).play();
        });
    }

    /**
     * Show Newsletter Consent as soon as Checkbox is checked
     * @description Show Newsletter Consent
     */
    if (plugins.newsletterConsent.length) {
        $( ".js-newsletter-checkbox" ).change(function(e) {
            $(".js-newsletter-consent").toggle('slow', 'linear');
        });
    }
});
